module.exports = __webpack_public_path__ + "img/03_uk.0094163f.svg";